import { bootstrap } from '@/app/bootstrap';
import '@/styles/app.scss';

void bootstrap();
